interface ClosedEyeIconProps {
  width?: number;
  height?: number;
  color?: string;
}

export const ClosedEyeIcon: React.FC<ClosedEyeIconProps> = ({
  width = 24,
  height = 24,
  color = 'black'
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 10c2 3 6 5 8 5s6-2 8-5" />
      <line x1="6" y1="13.5" x2="5.5" y2="16" />
      <line x1="10" y1="14.5" x2="9.5" y2="17" />
      <line x1="14" y1="14.5" x2="14.5" y2="17" />
      <line x1="18" y1="13.5" x2="18.5" y2="16" />
    </svg>
  );
};
